



























import { Vue, Component, Prop } from 'vue-property-decorator';
import EvoTalksFilaAtendenteModel from '@/models/crm/evotalks-fila-atendente.model';

@Component({})
export default class EvoTalksQueueSelectDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({ default: () => [] })
  queues!: EvoTalksFilaAtendenteModel[];
}
